import { noop } from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@adscore/with-responsive-size';

import { STATES } from './use-dynamic-flow-state';
import { PreviewShimmer } from './preview-shimmer';
import { PreviewResult } from './preview-result';
import { getPreviewSectionStyles } from '../styles/preview-section-styles';

export function PreviewSection({
  currentState,
  triggerTransition,
  promptSuggestions,
  adSuggestions,
  onClickSignUp,
  website,
  setWebsite,
  prompt,
  setPrompt,
  signUpUrlWithCacheId,
  errorMessage,
  logger,
}) {
  const classes = useDefaultStyles(getPreviewSectionStyles);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);

  const isLoadingAdSuggestions = currentState === STATES.PREVIEW.LOADING_ADS;

  return (
    <div className={classNames('preview-content', classes.contentContainer, classes[`contentContainer-${displayMode}`])}>
      {isLoadingAdSuggestions ?
        <PreviewShimmer /> :
        <PreviewResult
          triggerTransition={triggerTransition}
          promptSuggestions={promptSuggestions}
          adSuggestions={adSuggestions}
          onClickSignUp={onClickSignUp}
          website={website}
          setWebsite={setWebsite}
          prompt={prompt}
          setPrompt={setPrompt}
          signUpUrlWithCacheId={signUpUrlWithCacheId}
          errorMessage={errorMessage}
          logger={logger}
        />
      }
    </div>
  );
}

PreviewSection.propTypes = {
  currentState: PropTypes.string.isRequired,
  triggerTransition: PropTypes.func.isRequired,
  promptSuggestions: PropTypes.arrayOf(PropTypes.string),
  adSuggestions: PropTypes.shape({
    imageUrl: PropTypes.string,
    adData: PropTypes.shape({}),
  }),
  onClickSignUp: PropTypes.func.isRequired,
  website: PropTypes.string.isRequired,
  setWebsite: PropTypes.func.isRequired,
  prompt: PropTypes.string.isRequired,
  setPrompt: PropTypes.func.isRequired,
  signUpUrlWithCacheId: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  logger: PropTypes.shape({
    trace: PropTypes.func.isRequired,
  }),
};

PreviewSection.defaultProps = {
  adSuggestions: {},
  promptSuggestions: [],
  errorMessage: '',
  logger: {
    trace: noop,
  },
};
